import { Stack } from '@delmonicos/shared-design-system-react/src/components/stack/stack';
import { toCurrencyString } from '@delmonicos/shared-sdk/libs/core/src/utils/formatters/currency.formatters';
import { TransactionModel } from '@delmonicos/shared-sdk/libs/cpms/src/libs/charge-hub-service-lib/src/wrapper/outputs/transaction/paginated/transaction.model';
import { CellContext } from '@tanstack/react-table';

export interface TransactionListTotalCostCellProps
  extends CellContext<TransactionModel, TransactionModel['totalCost']> {}

export const TransactionListTotalCostCell = (
  props: TransactionListTotalCostCellProps,
): React.JSX.Element => {
  // CONTEXT ///////////////////////////////////////////////////////////////////

  const { row, getValue } = props;

  // RENDER ////////////////////////////////////////////////////////////////////

  return (
    <Stack justifyContent="flex-end">
      {getValue() ? toCurrencyString(getValue(), row.original.currency) : '-'}
    </Stack>
  );
};
